/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Recent_DescInputs */

const en_directory_launch_recent_desc = /** @type {(inputs: Directory_Launch_Recent_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fresh AI tools added recently.`)
};

const zh_directory_launch_recent_desc = /** @type {(inputs: Directory_Launch_Recent_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近期新收录的 AI 工具。`)
};

/**
* | output |
* | --- |
* | "Fresh AI tools added recently." |
*
* @param {Directory_Launch_Recent_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_recent_desc = /** @type {((inputs?: Directory_Launch_Recent_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Recent_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_recent_desc(inputs)
	return zh_directory_launch_recent_desc(inputs)
});
export { directory_launch_recent_desc as "directory.launch.recent_desc" }